export default __webpack_public_path__ + "static/media/resturant-menu-theme-4.e6d7ede2.jpg";